import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import Button from '../../../../../Form/Button';
import InfoIcon from './InfoIcon';

interface Props {
  name: string;
  publishing: () => void;
}

function NotPublishedBanner({ name, publishing }: Props) {
  return (
    <div
      className={clsx(
        'rounded-sm bg-yellow-50 border-yellow-300 flex justify-between w-4/5 lg:my-12',
        'my-2.5 mx-auto p-5 border-2',
      )}
    >
      <div className="flex items-center">
        <InfoIcon />
        <div className="flex flex-col">
          <span className="font-bold">
            <T kind="Collection not Published" />
          </span>
          <span>
            <T
              kind="The {{name}} collection is not published. Participants will not have access using the Program Deep Links."
              name={name}
            />
          </span>
        </div>
      </div>
      <Button
        className="rounded-md bg-teal-600 px-6 py-2 text-white"
        value="Publish Collection"
        onClick={publishing}
        type="button"
      />
    </div>
  );
}

export default observer(NotPublishedBanner);
